<template lang="pug">
  .time-slot-list
    time-slot(v-for="(availability, index) in availabilitiesToDisplay" :disabled="disabled" :key="index" @delete="deleteAvailability" :availability="availability" :index="index" :periods="periods")

    .invisible
      div(v-for="availability in availabilitiesToDestroy")
        input(type='hidden' :name="nameFor(availability, 'id')" :value="availability.attributes.id")
        input(type='hidden' :name="nameFor(availability, '_destroy')" :value="availability.attributes._destroy")

    /// ADD AVAILABILITY
    .row.form-group(v-if="!disabled")
      .col-md-9.offset-md-3.text-left
        a(@click.prevent="addAvailability" href="#")
          i.fal.fa-plus-circle
          span {{ $t("components.time_slot.add_availability") }}

</template>

<script>
  import TimeSlot from '@appComponents/TimeSlot'
  import { clone } from 'lodash'

  export default {
    components: {
      TimeSlot
    },
    props: {
      resourceUrl: String,
      periods: Array,
      disabled: {
        type: Boolean,
        default: false
      },
      availabilities: {
        type: Array,
        default () {
          return [{
            id: 1,
            attributes: {
              date: undefined,
              period: 'Matin',
              _destroy: false
            }
          }]
        }
      }
    },
    data () {
      return {
        mutableAvailabilities: this.availabilities
      }
    },
    computed: {
      availabilitiesToDisplay () {
        return this.mutableAvailabilities.filter(availability => !availability.attributes._destroy)
      },
      availabilitiesToDestroy () {
        return this.mutableAvailabilities.filter(availability => availability.attributes._destroy)
      }
    },
    methods: {
      addAvailability () {
        this.mutableAvailabilities.push({
          id: (this.mutableAvailabilities.length + 1),
          attributes: {
            date: new Date(Date.now() - 8640000),
            period: "all_day",
            _destroy: false
          }
        })
      },

      deleteAvailability (availability) {
        var index = this.mutableAvailabilities.indexOf(availability)
        var availabilityToDestroy = clone(availability)
        availabilityToDestroy.attributes._destroy = true

        this.mutableAvailabilities.splice(index, 1, availabilityToDestroy)
      },

      nameFor (availability, attribute) {
        let id = -1 - this.availabilities.indexOf(availability)

        if (availability.id) {
          id = availability.id
        }

        return "appointment_request[time_slots_attributes][" + id + "][" + attribute + "]"
      }
    },
    watch: {
      mutableAvailabilities: {
        deep: true,
        handler () {
          const attributes = this.availabilities.map(availibility => availibility.attributes)
          this.$parent.$emit("change", attributes)
        }
      }
    }
  }
</script>
